import { render, staticRenderFns } from "./DiscussList.vue?vue&type=template&id=8341c6d2&"
import script from "./DiscussList.vue?vue&type=script&lang=js&"
export * from "./DiscussList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports